'use strict';

var FaresOptimizerAnalysisRecommendationGridsDirective = function FaresOptimizerAnalysisRecommendationGridsDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerAnalysisRecommendationGridsController',
    template: require('../templates/fares-optimizer-analysis-recommendation-grids.html'),
    scope: {
      screenState: '='
    }
  };
};
FaresOptimizerAnalysisRecommendationGridsDirective.$inject = [];
module.exports = FaresOptimizerAnalysisRecommendationGridsDirective;